// extracted by mini-css-extract-plugin
export var SearchHeading = "SearchBar-module--SearchHeading--25vq_";